import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../state'
import * as shared from '../../../../../shared'

/** Identifies this report to the configuration plugin. */
const REPORT_ID = ents.extra.space.Report.Id.RoomsByResponsiblePerson

/** Page content for the Rooms by Responsible Person space report. */
@ngCore.Component({
  imports: [
    ds.input.select.single.Component,
    ds.layout.section.Component,
    ds.layout.widget.Component,
    shared.dimensionFilter.Component,
  ],
  selector: 'atn-space-report-rooms-by-responsible-person',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.space.reports.Collection} */
  private readonly _reportsEc = ngCore.inject(state.space.reports.Collection)

  /** @see {@link state.space.reports.plugins.configuration.Plugin} */
  public readonly configurationPlugin = this._reportsEc.plugins
    .lookup(state.space.reports.plugins.configuration.Plugin)
    .get()

  /** @see {@link state.space.reports.plugins.employeeDimensionFilter.Plugin} */
  public readonly employeeFilterPlugin = this._reportsEc.plugins
    .lookup(state.space.reports.plugins.employeeDimensionFilter.Plugin)
    .get()

  /** Configuration settings for this report */
  public readonly configurationSg =
    this.configurationPlugin.selectors.getSettings(REPORT_ID).asSignal

  /** Options for the format select. */
  public readonly formatItems: readonly ds.input.select.models.Item<ents.extra.space.Report.Format>[] =
    ents.extra.space.Report.Format.SUPPORTED.map(format => ({
      label: ents.extra.space.Report.Format.getLabel(format),
      value: format,
    }))

  /**
   * Handles a change to the format select.
   *
   * NOTE: format is required, so a cleared selection is ignored to keep the
   * last valid value.
   */
  public formatChangeHandler(
    value: ents.extra.space.Report.Format | undefined,
  ): void {
    if (value) {
      this.configurationPlugin.actions.edit
        .from(
          'SpaceReport.RoomsByResponsiblePerson.Configuration.Format.Changed',
        )
        .dispatch({ edit: { format: value }, id: REPORT_ID })
    }
  }
}
